export default __webpack_public_path__ + "static/media/drinks_list_2.703b886e.png";